(function () {
  if (window.__appdInit) return;
  window.__appdInit = true;

  var CHECK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  function money(cents) { return '€' + (cents / 100).toFixed(2); }

  class AppearanceDropdown extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.appd-trigger');
      this.list = this.querySelector('.appd-list');
      this.current = this.querySelector('.appd-current');
      var id = this.getAttribute('data-appd-target');
      this.select = id ? document.getElementById(id) : null;
      if (!this.trigger || !this.list) return;
      var self = this;
      this._onDoc = function (e) { if (!self.contains(e.target)) self.close(); };
      this.trigger.addEventListener('click', function (e) { e.stopPropagation(); self.toggle(); });
      this.list.querySelectorAll('.appd-opt').forEach(function (opt) { opt.addEventListener('click', function () { self.choose(opt); }); });
      document.addEventListener('click', this._onDoc);
      this.renderDeltas();
      this.updateTrigger();
    }
    disconnectedCallback() { if (this._onDoc) document.removeEventListener('click', this._onDoc); }
    toggle() { var open = this.classList.toggle('open'); this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    close() { this.classList.remove('open'); if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false'); }
    choose(opt) {
      var value = opt.getAttribute('data-value');
      this.setSelected(value);
      this.close();
      if (this.select) { this.select.value = value; this.select.dispatchEvent(new Event('change', { bubbles: true })); }
      this.renderDeltas();
      this.updateTrigger();
    }
    setSelected(value) {
      this.list.querySelectorAll('.appd-opt').forEach(function (o) {
        var on = o.getAttribute('data-value') === value;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    updateTrigger() {
      if (!this.current) return;
      var sel = this.list.querySelector('.appd-opt.is-selected') || this.list.querySelector('.appd-opt');
      if (!sel) return;
      var nameEl = sel.querySelector('.appd-name');
      var badge = sel.querySelector('.appd-badge');
      this.current.innerHTML = '';
      var nameSpan = document.createElement('span');
      nameSpan.className = 'appd-current-name';
      nameSpan.textContent = nameEl ? nameEl.textContent : sel.getAttribute('data-value');
      this.current.appendChild(nameSpan);
      if (badge) this.current.appendChild(badge.cloneNode(true));
    }
    renderDeltas() {
      var sel = this.list.querySelector('.appd-opt.is-selected') || this.list.querySelector('.appd-opt');
      if (!sel) return;
      var base = parseInt(sel.getAttribute('data-price'), 10);
      this.list.querySelectorAll('.appd-opt').forEach(function (o) {
        var slot = o.querySelector('.appd-right');
        if (!slot) return;
        if (o.classList.contains('is-selected')) { slot.innerHTML = '<span class="appd-check" aria-hidden="true">' + CHECK + '</span>'; return; }
        if (o.getAttribute('data-available') !== 'true') { slot.innerHTML = '<span class="appd-soldout">Sold out</span>'; return; }
        var d = parseInt(o.getAttribute('data-price'), 10) - base;
        if (isNaN(d) || d === 0) { slot.innerHTML = ''; return; }
        var sign = d > 0 ? '+' : '−';
        var cls = d > 0 ? 'appd-up' : 'appd-down';
        slot.innerHTML = '<span class="appd-delta ' + cls + '">' + sign + ' ' + money(Math.abs(d)) + '</span>';
      });
    }
  }

  if (!customElements.get('appearance-dropdown')) { customElements.define('appearance-dropdown', AppearanceDropdown); }

  document.addEventListener('click', function (e) {
    var info = e.target.closest ? e.target.closest('.appd-info') : null;
    if (info) { var m = document.getElementById(info.getAttribute('data-appd-info')); if (m) m.classList.add('is-open'); return; }
    var c = e.target.closest ? e.target.closest('.appd-info-close, .appd-info-backdrop') : null;
    if (c) { var mm = c.closest('.appd-info-modal'); if (mm) mm.classList.remove('is-open'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var open = document.querySelectorAll('.appd-info-modal.is-open'); for (var i = 0; i < open.length; i++) open[i].classList.remove('is-open'); }
  });
})();
